'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _themeSections = require('@shopify/theme-sections');

var _themeSections2 = _interopRequireDefault(_themeSections);

require('../sections/faqs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaqsSection = function FaqsSection() {
  (0, _classCallCheck3.default)(this, FaqsSection);

  _themeSections2.default.load('faqs');
};

exports.default = FaqsSection;